import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from '@nuxtjs/composition-api'
import { useRestaurantModel } from '@entities/restaurant'

import { bannerClick, bannerTransition } from './../api'
import { getBannerReview } from './../utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewInteresting',
  setup(__props) {

const restaurantModel = useRestaurantModel()

const dataBanner = computed(() => getBannerReview(restaurantModel.code))
const defaultBannerSrc = computed(() => {
  try {
    return require('./../assets/banner_' + dataBanner.value.img)
  } catch (error) {
    return require('./../assets/banner_mistral.jpg')
  }
})
const bigBannerSrc = computed(() => {
  const bigBannerName = dataBanner.value.img.replace(/(\.[^.]+)$/, '-big$1')

  try {
    return require('./../assets/banner_' + bigBannerName)
  } catch (error) {
    return ''
  }
})

const clickOnBanner = () => {
  bannerClick(restaurantModel.code, dataBanner.value.id)
}

onMounted(() => {
  bannerTransition(restaurantModel.code, dataBanner.value.id)
})


return { __sfc: true,restaurantModel, dataBanner, defaultBannerSrc, bigBannerSrc, clickOnBanner }
}

})